import { NgModule } from '@angular/core';

import { CmpsCardBodyComponent } from './card-body.component';
import { CmpsCardHeaderComponent } from './card-header.component';
import { CmpsCardComponent } from './card.component';
import { CmpsStackedCardComponent } from './stacked-card.component';

@NgModule({
    declarations: [
        CmpsCardBodyComponent,
        CmpsCardComponent,
        CmpsCardHeaderComponent,
        CmpsStackedCardComponent,
    ],
    exports: [
        CmpsCardBodyComponent,
        CmpsCardComponent,
        CmpsCardHeaderComponent,
        CmpsStackedCardComponent,
    ],
    imports: [],
})
export class CmpsCardModule {}
